__turbopack_context__.v({
  "blurContent": "UGd7zq_blurContent",
  "dissolved": "UGd7zq_dissolved",
  "fog": "UGd7zq_fog",
  "fog-drift": "UGd7zq_fog-drift",
  "fogged": "UGd7zq_fogged",
  "label": "UGd7zq_label",
  "spoilerFog": "UGd7zq_spoilerFog",
  "veil": "UGd7zq_veil",
});
